module.exports = "https://static.web-explore.prod.greetz-nl.net/_next/static/images/logo-square-dd0096f9364ce13f7891d9cdd21b1db0.png";